import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import './style.css';
import HomeScreen from './home';
function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const { getInitData} = useRefresh();

    const [showHome, setShowHome] = useState(false);
   


     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    

     useEffect(() => {
            console.log(goHomeInit, 'q mas qlq')
              setShowHome(false)
     }, [goHomeInit]);
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
           setShowHome(false)
            getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    

    return (
        <div
             onClick={() => setShowHome(true)}
            className='backgroundlayout'
            style={{ width: '100%', height: '100%', paddingTop: 30 }}
        >
                <h3 style={{color: 'white', fontSize: 30}}>WELCOME / BIENVENIDOS</h3>
                <div>
                    <img
                        style={{
                            width: 400,
                            height: 400,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            borderRadius: 40
                            
                        }}
                        src={require('./assets/logo.png')}
                />
                

                <img
                        style={{
                            width: 600,
                            height: 250,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            borderRadius: 40
                            
                        }}
                        src={require('./assets/bannerwebsite.png')}
                    />

                <div style={{display: 'flex', width: "100%", justifyContent: "center", gap: 40, marginTop: 80}}>
                    <div
                        onClick={() => setShowHome(true)}
                        style={{
                            background: 'linear-gradient(to right, #e94040, #b00b0b)', // degrade rojo
                            border: '1px solid white',
                            borderRadius: '10px',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '24px',
                            padding: '16px 32px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            display: 'inline-block',
                            boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
                            letterSpacing: '1px'
                        }}
                        >
                        <p style={{
                            color: '#fff',
                            fontWeight: 'bold',
                           
                            fontSize: '18px',
                       }}> TAP FOR MENU</p>
                    </div>
                    <div
                        onClick={() => setShowHome(true)}
                        style={{
                            background: 'linear-gradient(to right, #e94040, #b00b0b)', // degrade rojo
                            border: '1px solid white',
                            borderRadius: '10px',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '24px',
                            padding: '16px 32px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            display: 'inline-block',
                            boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
                            letterSpacing: '1px'
                        }}
                        >
                        <p style={{
                            color: '#fff',
                            fontWeight: 'bold',
                           
                            fontSize: '18px',
                       }}> TAP FOR MENU</p>
                    </div>
                    </div>
                </div>
           

             {showHome && <HomeScreen  />}
            
        </div>
    );
}

export default Index;